import React from 'react';
import LandingMainImage from './images/landing-main-image.jpg';
import './styles.scss';

const Landing = ({children}) => {
  return (
    <div className="l-landing">
      <div className="l-landing__info">
        {children}
      </div>
      <div className="l-landing__image-container">
        <img
          src={LandingMainImage}
          alt="Landing main image"
          className="l-landing__image"/>
      </div>
    </div>
  );
};

export default Landing;
